<template>
  <LRX75Hero>
    <template v-slot:header>Commercial shark finning</template>
    <template v-slot:image
      ><img src="https://www.flaticon.com/svg/static/icons/svg/905/905576.svg"
    /></template>
    Commercial shark finning is the practice of catching a shark, removing it's
    fin, and then discarding the rest of the animal into the sea, where it dies
    a slow and painful death. This valuable resource is often used in
    traditional Chinese medicines, and shark fin soup.
  </LRX75Hero>
</template>

<script>
import LRX75Hero from "@/components/LRX75Hero.vue";

export default {
  name: "2CommercialSharkFinning",
  components: {
    LRX75Hero
  }
};
</script>
